app.directive('back', ['$window', function($window) {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
            elem.bind('click', function(){
                $window.history.back();
            });
        }
    };
}]);


app.directive('stRatio',function(){
    return {
        link:function(scope, element, attr){
            var ratio=+(attr.stRatio);

            element.css('width',ratio+'%');

        }
    };
});

app.directive('sort', function() {
    return {
      restrict: 'A',
      transclude: true,
      template:
        '<a ng-click="onClick()" style="color:#333 !important; cursor:pointer">' +
        '<span ng-transclude></span> ' +
        '<i class="fa fa-1" ng-class="{\'fa-chevron-up\' : order === by && !reverse,  \'fa-chevron-down\' : order===by && reverse}"></i>' +
        '</a>',
      scope: {
        order: '=',
        by: '=',
        reverse: '='
      },
      link: function(scope, element, attrs) {
        scope.onClick = function() {
          if (scope.order === scope.by) {
            scope.reverse = !scope.reverse
          } else {
            scope.by = scope.order
            scope.reverse = false
          }
        }
      }
    }
  })


app.directive('hoverClass', function () {
    return {
        restrict: 'A',
        scope: {
            hoverClass: '@'
        },
        link: function (scope, element) {
            element.on('mouseenter', function() {
                element.addClass(scope.hoverClass);
            });
            element.on('mouseleave', function() {
                element.removeClass(scope.hoverClass);
            });
        }
    };
})
